import { render, staticRenderFns } from "./AsociarEventosFormEdit2.vue?vue&type=template&id=46ff816e&scoped=true&"
import script from "./AsociarEventosFormEdit2.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosFormEdit2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosFormEdit2.vue?vue&type=style&index=0&id=46ff816e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff816e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46ff816e', component.options)
    } else {
      api.reload('46ff816e', component.options)
    }
    module.hot.accept("./AsociarEventosFormEdit2.vue?vue&type=template&id=46ff816e&scoped=true&", function () {
      api.rerender('46ff816e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/AsociarEventosFormEdit2.vue"
export default component.exports